import mobileNav from './Template/mobileNav';
import search from './Template/search';
import totopbtn from './Template/totopbtn';
import glideSliderTeaser from './Modules/Slider/glideSliderTeaser';
import logosliderDefault from './Modules/Slider/logosliderDefault';
import logosliderBrand from './Modules/Slider/logosliderBrand';
import logosliderPortrait from './Modules/Slider/logosliderPortrait';
import stageslider from './Modules/Slider/stageslider';
import infocard from './Modules/infocard';
import factsfigures from './Modules/factsfigures';
import teaserClassic from './Modules/teaserClassic';
import teaserPillar from './Modules/teaserPillar';
import videoonsite from './Modules/videoonsite';
import videoyoutube from './Modules/videoyoutube';
import locationsmap from './Modules/locationsmap';
import news from './Modules/news';
import form from './Template/form';
import socialIconModal from './Template/socialIconModal';
import domainNavigationPopUp from './Template/domainNavigationPopUp';
import udgLinkBrowser from './Extensions/udgLinkBrowser';

(function main() {
    mobileNav();
    search();
    totopbtn();
    glideSliderTeaser();
    logosliderDefault();
    logosliderBrand();
    logosliderPortrait();
    stageslider();
    infocard();
    factsfigures();
    teaserClassic();
    teaserPillar();
    videoonsite();
    videoyoutube();
    locationsmap();
    news();
    form();
    socialIconModal();
    domainNavigationPopUp();
    udgLinkBrowser();
}());
